const ErrorMonitor = {
  errors: [],
  init() {
    window.onerror = (msg, src, line, col, err) => {
      this.capture(err || new Error(msg), { source: src, line, col });
    };
    window.onunhandledrejection = (event) => {
      this.capture(event.reason, { type: 'unhandled_promise' });
    };
  },
  _sent: [],
  capture(error, context = {}) {
    const status = error?.response?.status;
    // Expected HTTP outcomes (session expired, rate-limited, not found) are not app errors; reporting them
    // only adds traffic at the worst possible moment.
    if (status === 401 || status === 403 || status === 404 || status === 429) return;
    const entry = {
      message: error?.message || String(error),
      stack: error?.stack,
      context,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
    };
    this.errors.push(entry);
    if (this.errors.length > 100) this.errors.shift();
    console.error('[ErrorMonitor]', entry);
    const now = Date.now();
    this._sent = this._sent.filter((t) => now - t < 60000);
    if (this._sent.length >= 5) return;   // cap error reports at 5/minute per tab
    this._sent.push(now);
    fetch('/api/errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(entry),
    }).catch(() => {});
  },
  getErrors() { return [...this.errors]; },
};

export default ErrorMonitor;
